<app-sticky-header>
  <ng-container left>
    @if (project && !showInExecutionSteps()) {
      <button
        type="button"
        class="project-nav-toggle"
        [class.project-nav-toggle--active]="navMenu?.isOpen()"
        [attr.aria-expanded]="navMenu?.isOpen()"
        [attr.aria-label]="'NAV.project.menuToggle' | translate"
        (click)="navMenu?.toggle()"
      >
        <vwui-icon iconName="vwui-menu"></vwui-icon>
      </button>
    }
    <div class="back-link project-name">
      <vwui-tooltip position="bottom" [label]="'NAV.project.all' | translate">
        <a [routerLink]="['/projecten']"><vwui-icon iconName="back"></vwui-icon> {{ project?.name }}</a>
      </vwui-tooltip>
    </div>
    @if (project) {
      <span style="display: none;" a11yPageTitleLevel="1">{{ project.name }}</span>
    }
  </ng-container>

  <div class="button-group" right>
    <vwui-menu class="header-menu" id="projectMenu">
      <vwui-menu-option (click)="downloadResult()" a11yKeyboardClickable>
        <vwui-icon iconName="vwui-file"></vwui-icon>
        {{ 'PROJECT_MENU.download' | translate }}
      </vwui-menu-option>

      @if (!project?.isEditLocked()) {
        <vwui-menu-option (click)="openNewVersionModal()" a11yKeyboardClickable>
          <vwui-icon iconName="vwui-add"></vwui-icon>
          {{ 'PROJECT_MENU.new_version' | translate }}
        </vwui-menu-option>
      }

      <vwui-menu-option (click)="openVersionsListModal()" a11yKeyboardClickable>
        <vwui-icon iconName="vwui-layers"></vwui-icon>
        {{ 'PROJECT_MENU.versions_list' | translate }}
      </vwui-menu-option>

      @if (!isClosed()) {
        <ng-container [ngTemplateOutlet]="disabledForNonEditors() ? menuOptionShareDisabled : menuOptionShare"></ng-container>
        <ng-template #menuOptionShare>
          <vwui-menu-option (click)="shareProject($event)" [ngClass]="{'is-disabled': disabledForNonEditors()}" a11yKeyboardClickable>
            <vwui-icon iconName="share"></vwui-icon>
            {{ 'PROJECT_MENU.share' | translate }}
          </vwui-menu-option>
        </ng-template>
        <ng-template #menuOptionShareDisabled>
          <vwui-tooltip [label]="disabledForNonEditors() | translate" position="left" class="is-block">
            <ng-container [ngTemplateOutlet]="menuOptionShare"></ng-container>
          </vwui-tooltip>
        </ng-template>

        <ng-container [ngTemplateOutlet]="disabledForChangeProjectType() ? menuOptionChangeTypeDisabled : menuOptionChangeType"></ng-container>
        <ng-template #menuOptionChangeType>
            <vwui-menu-option (click)="changeProjectType($event)" [ngClass]="{'is-disabled': disabledForChangeProjectType()}" a11yKeyboardClickable>
                <vwui-icon iconName="vwui-edit"></vwui-icon>
                {{ 'PROJECT_MENU.change_project_type' | translate }}
            </vwui-menu-option>
        </ng-template>
        <ng-template #menuOptionChangeTypeDisabled>
            <vwui-tooltip [label]="disabledForChangeProjectType() | translate" position="left" class="is-block">
                <ng-container [ngTemplateOutlet]="menuOptionChangeType"></ng-container>
            </vwui-tooltip>
        </ng-template>

        <ng-container [ngTemplateOutlet]="disabledForOnHold() ? menuOptionOnHoldDisabled : menuOptionOnHold"></ng-container>
        <ng-template #menuOptionOnHold>
          <vwui-menu-option (click)="changeProjectOnHoldStatus($event)" [ngClass]="{'is-disabled': disabledForOnHold()}"  a11yKeyboardClickable>
            @if (!project?.isOnHold()) {
              <vwui-icon iconName="pause-circle"></vwui-icon>
              {{ 'PROJECT_MENU.on_hold' | translate }}
            } @else {
              <vwui-icon iconName="play-circle"></vwui-icon>
              {{ 'PROJECT_MENU.on_resume' | translate }}
            }
          </vwui-menu-option>
        </ng-template>
        <ng-template #menuOptionOnHoldDisabled>
          <vwui-tooltip [label]="disabledForOnHold() | translate" position="left" class="is-block">
            <ng-container [ngTemplateOutlet]="menuOptionOnHold"></ng-container>
          </vwui-tooltip>
        </ng-template>
        @if (enabledForClosing()) {
          <vwui-menu-option (click)="setProjectToClosed($event)" a11yKeyboardClickable>
            <vwui-icon iconName="vwui-close"></vwui-icon>
            {{ 'PROJECT_MENU.close' | translate }}
          </vwui-menu-option>
        }
        <ng-container [ngTemplateOutlet]="disabledForArchiving() ? menuOptionArchiveDisabled : menuOptionArchive"></ng-container>
        <ng-template #menuOptionArchive>
          <vwui-menu-option (click)="setProjectToArchived($event)" [ngClass]="{'is-disabled': disabledForArchiving()}" a11yKeyboardClickable>
            <vwui-icon iconName="vwui-trash"></vwui-icon>
            {{ 'PROJECT_MENU.archive' | translate }}
          </vwui-menu-option>
        </ng-template>
        <ng-template #menuOptionArchiveDisabled>
          <vwui-tooltip [label]="disabledForArchiving() | translate" position="left" class="is-block">
            <ng-container [ngTemplateOutlet]="menuOptionArchive"></ng-container>
          </vwui-tooltip>
        </ng-template>
      }

      @for (link of projectLinks(); track link.id) {
        <vwui-menu-option class="project-link-option" (click)="openProjectLink(link)" a11yKeyboardClickable>
          <vwui-icon [iconName]="isMailLink(link.link) ? 'mail' : 'link'"></vwui-icon>
          {{ link.title }}
        </vwui-menu-option>
      }
    </vwui-menu>

    @if (stepId === projectSteps.QUICKSCAN && project && !project.isQuickscanFinalised()) {
      <vwui-button class="is-primary" [loading]="quickscanStep?.isDefinitiefSaving" [disabled]="project?.isQuickscanFinalised()" (click)="confirmSubmitProjectIntake()" [appDisabledReason]="(quickscanStep?.definitiefDisabledReason() ?? '') | translate">
        {{ 'PAGE_QUICKSCAN_RESULT.button.save' | translate }}
      </vwui-button>
    }
  </div>
</app-sticky-header>

@if (project) {
  <app-project-nav-menu [projectDetails]="project" [stepId]="stepId"></app-project-nav-menu>
}

@if (project) {
  <div class="step-content step-content--with-menu">
  @if (stepId === projectSteps.DETAILS) {
    <app-project-analysis-details class="skip-element" [projectDetails]="project" (isFormValid)="projectDetailsValid($event)" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-analysis-details>
  }
  @if (stepId === projectSteps.QUICKSCAN && project && quickscanStepVisible) {
    <app-project-analysis-questions class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-analysis-questions>
  }
  @if (stepId === projectSteps.RISKS && project) {
    <app-project-risks class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-risks>
  }
  @if (stepId === projectSteps.OPPORTUNITIES && project) {
    <app-project-opportunities class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-opportunities>
  }
  @if (stepId === projectSteps.TASKS && project) {
    <app-project-tasks class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-tasks>
  }
  @if (stepId === projectSteps.DOSSIER && project) {
    <app-project-risk-dossier class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-risk-dossier>
  }
  @if (stepId === projectSteps.RAINBOW && project) {
    <app-project-risk-rainbow class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-risk-rainbow>
  }
  @if (stepId === projectSteps.MANDATING) {
    <app-project-mandating class="skip-element" [projectDetails]="project" (projectDetailsChanged)="projectDetailsChanged($event)"></app-project-mandating>
  }
  </div>
}
